import React from "react";
import ConfirmDialog from "../../../../components/genericform/ConfirmDialog";

interface DeleteStaffDialogProps {
  open: boolean;
  staffName: string;
  isProcessing?: boolean;
  onClose: () => void;
  onDelete: () => Promise<boolean> | boolean;
}

const DeleteStaffDialog: React.FC<DeleteStaffDialogProps> = ({ open, staffName, isProcessing = false, onClose, onDelete }) => {
  const handleConfirm = () => {
    if (isProcessing) return;
    onDelete();
  };
  return (
    <ConfirmDialog
      open={open}
      title="Confirm To Delete"
      description={`Are you sure you want to delete the staff member: "${staffName}"?`}
      confirmLabel="Delete"
      cancelLabel="Cancel"
      isProcessing={isProcessing}
      disableConfirm={isProcessing} // ✅ disables button
      onConfirm={handleConfirm}
      onCancel={onClose}
    />
  );
};

export default DeleteStaffDialog;